import { createRootRoute, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Layout/Layout";
import { useAuth } from "../lib/use-auth";

export const rootRoute = createRootRoute({
	component: RootComponent,
});

function RootComponent() {
	const { user, isLoading, refetch } = useAuth();
	const navigate = useNavigate();
	const { location } = useRouterState();
	const isLoginPage = location.pathname === "/login";
	const { t } = useTranslation();

	useEffect(() => {
		if (isLoading) return;

		if (!user && !isLoginPage) {
			navigate({ to: "/login", replace: true });
		}

		if (user && isLoginPage) {
			navigate({ to: "/", replace: true });
		}
	}, [user, isLoading, isLoginPage, navigate]);

	useEffect(() => {
		if (!isLoginPage) refetch();
	}, [location.pathname, isLoginPage, refetch]);

	if (isLoading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100dvh",
				}}
			>
				{t("loading")}
			</div>
		);
	}

	if (!user && !isLoginPage) {
		return null;
	}

	if (isLoginPage) {
		return <Outlet />;
	}

	return (
		<Layout>
			<Outlet />
		</Layout>
	);
}
